import store from "~/store";

export default async (to, from, next) => {
    store.dispatch('page/updateLoading', {
        loading: true,
    });
    /* store.dispatch('page/clearFilters', {
        loading: true,
    }); */
    next();
};
